export default __webpack_public_path__ + "static/media/exafluence.29716678.png";